<div class="container text-center text-white py-3">
    <div class="welcome-to">Our</div>
    <h2>Rates</h2>
</div>

<div class="container p-3 text-white text-center">

    <div class="card bg-body-tertiary bg-opacity-75 p-3 px-5">

        <h3 class="py-3">OPEN SLIPS</h3>

        <p>Membership is $3850.00/year + HST</p>
        <p>We can accommodate boats up to 22 feet.  Price includes 2 dedicated parking spots.  Trailer storage is available.  Winterizing and shrink wrapping are also available.</p>

    </div>
    <div class="card bg-body-tertiary bg-opacity-75 p-3 px-5 mt-2">

        <h3 class="py-3">LAUNCH RAMP</h3>

        <p>Launch ramp is available and included for members only.</p>

    </div>

    <div class="py-4">&nbsp;</div>
        
</div>